/**
 * Alatreyu Custom Animations
 * Complements Horizon's built-in scroll-trigger system.
 *
 * Horizon handles: .scroll-trigger + .animate--fade-in / .animate--slide-in
 * This handles:    .alatreyu-animate (custom sections not using Horizon patterns)
 *
 * Usage in Liquid:
 *   <div class="alatreyu-animate">Fades in on scroll</div>
 *   <div class="alatreyu-stagger">
 *     <div class="alatreyu-animate">Child 1 (0ms delay)</div>
 *     <div class="alatreyu-animate">Child 2 (80ms delay)</div>
 *   </div>
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function initAlatreyuAnimations(root) {
    var elements = (root || document).querySelectorAll('.alatreyu-animate:not(.visible)');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAlatreyuAnimations();
    });
  } else {
    initAlatreyuAnimations();
  }

  // Re-initialize when Shopify theme editor loads a section
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initAlatreyuAnimations(event.target);
    });
  }
})();
